import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/landing";
import { Reveal } from "@/components/landing/primitives";

export const FaqSection = () => (
  <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="text-center">
          <p className="text-sm tracking-wider uppercase font-semibold text-afwn-green">FAQ</p>
          <h2 className="mt-3 font-heading font-light tracking-tight text-4xl lg:text-5xl">Questions, answered</h2>
        </div>
      </Reveal>
      <Reveal i={1}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i + 1}`} className="bg-white border border-afwn-navy/10 rounded-2xl px-6 overflow-hidden">
              <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="text-left font-medium text-afwn-navy hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-afwn-slate leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
